import "../dialogConfirm/DialogConfirm.css";
import { type FC } from "react";
import { Box, Dialog, Stack, Typography } from "@mui/material";
import { ContainButtonShort, LinearTextDialog, OutlineButtonShort } from "../../utils";
import IconAccountActive from "../../assets/images/icons/active/active-icon-issuer.png";

interface DialogConfirmProps {
    open: any;
    title?: string;
    subTitle?: string;
    confirm: () => void;
    description?: string;
    address?: string;
    onClick?: () => void;
    onClose: () => void;
}

const DialogConfirm: FC<DialogConfirmProps> = ({
    open,
    title,
    subTitle,
    confirm,
    description,
    address,
    onClick,
    onClose
}) => {
    return (
        <Dialog
            open={open}
            keepMounted
            aria-describedby="dialog-slides"
            sx={{
                zIndex: 1301,
                "& .MuiDialog-paper": {
                    background: "var(--bg-dialog)",
                    borderRadius: "32px !important",
                    border: '1px solid var(--black)',
                    py: 5,
                    px: 3,
                    m: 2,
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    textAlign: "-webkit-center",
                    width: address ? "580px !important" : "420px !important",
                },
            }}
        >
            <Stack direction={'row'} gap={1} justifyContent={'center'}>
                <Typography fontSize={24} fontWeight={600}>{title}</Typography>
                <LinearTextDialog>{subTitle}</LinearTextDialog>
            </Stack>
            {description && <Typography fontSize={12} fontWeight={400} mt={2}>{description}</Typography>}
            {address &&
                <Box mt={3} display={'flex'} alignItems={'center'} justifyContent={'center'}>
                    <img src={IconAccountActive} alt="IconAccountActive" width={40} height={40} />
                    <Box sx={{ border: '1px solid var(--black)', borderRadius: '25px', padding: '8px 24px', ml: 2 }}>
                        <Typography fontSize={12} fontWeight={400}>{address}</Typography>
                    </Box>
                </Box>
            }
            <Stack direction={'row'} gap={1} justifyContent={'center'} mt={3}>
                <ContainButtonShort onClick={confirm}>Confirm</ContainButtonShort>
                <OutlineButtonShort onClick={onClose}>Cancel</OutlineButtonShort>
            </Stack>
        </Dialog>
    );
};

export default DialogConfirm;
